import { render } from "./event-card.vue?vue&type=template&id=0337540f&scoped=true"
import script from "./event-card.vue?vue&type=script&lang=js"
export * from "./event-card.vue?vue&type=script&lang=js"

import "./event-card.vue?vue&type=style&index=0&id=0337540f&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0337540f"]])

export default __exports__